import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const ChargeEcoV2SquareIcon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				d="M24 3.1647V20.8348C24 22.5831 22.5826 24 20.8348 24H3.16516C1.41691 24 0 22.5831 0 20.8348V3.1647C0 1.41691 1.41691 0 3.16516 0H20.8348C22.5826 0 24 1.41691 24 3.1647Z"
				stroke="transparent"
			/>
			<Path
				d="M9.16647 19.4444C8.36053 18.9478 9.37882 16.3094 9.67629 14.5154C9.84975 13.4692 7.60677 14.1511 6.97246 13.9543C5.48919 13.4944 7.01822 10.8949 9.77652 8.0089C12.5353 5.12291 13.933 4.12385 14.9114 4.45656C15.8894 4.78974 14.7357 7.90455 14.3082 10.1246C14.0963 11.2235 16.5087 10.4578 17.1201 10.7352C18.0166 11.142 17.9544 12.25 14.4689 16.0033C10.9834 19.7565 9.77011 19.816 9.16692 19.4444"
				fill="white"
				stroke="transparent"
			/>
		</>
	),
});
